var React = require('react');

function Q1 (props) {
    return React.createElement("svg",props,React.createElement("g",{"fillRule":"nonzero","fill":"none"},[React.createElement("path",{"fill":"#FFC965","d":"M32 62h88v4H32z","key":0}),React.createElement("path",{"fill":"#D9E2EF","d":"M0 46h88v4H0z","key":1}),React.createElement("path",{"fill":"#FFC965","d":"M72 30h88v4H72z","key":2}),React.createElement("path",{"fill":"#D9E2EF","d":"M32 14h88v4H32z","key":3}),React.createElement("path",{"d":"M85.3 65.8c11 0 16-5 18.3-7.3l-1-1.2c-3 2-6.4 3.3-11 3.3-8.1 0-14.7-5.3-22.4-11.2a25.1 25.1 0 0018.4-24.2C87.6 10.5 75.7.8 61.2.8 47.5.8 34.7 11.4 34.7 26.2c0 11.8 7.3 20 17 23 11.3 9 20.2 16.6 33.6 16.6zm-23-17.5c-8.2 0-13.8-9.9-13.8-24C48.5 11 52.9 3.8 60 3.8c8.4 0 13.8 11.3 13.8 23.8 0 13.6-4.3 20.8-11.6 20.8zm57.6 1.7v-2.7l-7.5-1.2V1.3h-1L91.1 8.5l.5 2.6 8.9-.6v35.7l-8 1.1V50h27.4z","fill":"#196BE6","key":4})]));
}

Q1.defaultProps = {"width":"160","height":"66"};

module.exports = Q1;

Q1.default = Q1;
